"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiWaveCurationGroup } from "@/generated/models/ApiWaveCurationGroup";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
export const getWaveCurationGroupsQueryKey = (waveId: string) => [QueryKey.WAVE_CURATION_GROUPS, {
  wave_id: waveId
}] as const;
interface UseWaveCurationGroupsProps {
  readonly waveId: string;
  readonly enabled?: boolean | undefined;
}
export function useWaveCurationGroups(t0) {
  const $ = _c(8);
  const {
    waveId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== waveId) {
    t2 = getWaveCurationGroupsQueryKey(waveId);
    $[0] = waveId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== waveId) {
    t3 = async () => await commonApiFetch({
      endpoint: `waves/${waveId}/curation-groups`
    });
    $[2] = waveId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = enabled && !!waveId;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: 300000
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return useQuery(t5);
}